export const roleTabs = ["Instructors", "Students", "Access Role"];

export const tableFiltersByTab = {
  Instructors: ["All", "Active", "Inactive", "Pending", "Flagged"],
  Students: ["All", "Active", "Inactive"],
  "Access Role": ["Added User", "Invited User", "Added Role"],
};

export const avatarPalette = [
  "#A855F7",
  "#0EA5E9",
  "#14B8A6",
  "#F97316",
  "#8B5CF6",
  "#22C55E",
  "#EF4444",
  "#EAB308",
];

export const statusStyleMap = {
  active: "border-[#22C55E] bg-[#22C55E33] text-[#22C55E]",
  inactive: "border-[#FF0000] bg-[#FF000033] text-[#FF0000]",
  pending: "border-[#EFA51C] bg-[#EFA51C33] text-[#EFA51C]",
  flagged: "border-[#FDF63B] bg-[#FDF63B33] text-[#FDF63B]",
};

export const pageSize = 10;
